import { getPublicHeaders } from '@/requests/common/getPublicHeaders';

export { getPublicHeaders as getLibraryHeaders };

interface FetchLibraryDataParams<T> {
  url: string;
  transform: (data: unknown) => T | null;
}

export const fetchLibraryData = async <T>({
  url,
  transform,
}: FetchLibraryDataParams<T>): Promise<T | null> => {
  try {
    const res = await fetch(url, { headers: getPublicHeaders() });
    const response = await res.json();
    return transform(response);
  } catch {
    return null;
  }
};
